import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
	.react-tabs {
		.react-tabs__tab-list {
			border-bottom: 0;
			margin: 0 0 1px 20px;

			.react-tabs__tab {
				font-size: 16px;
				color: #fff;
				padding: 10px 14px;
				
				&.react-tabs__tab--selected {
					font-weight: 700;
					background-color: #0002;
					border: 0;

					&:focus {
						border: 0;
						box-shadow: unset;
					}
				}

				@media(max-width: 500px) {
					&:not(.react-tabs__tab--selected) {
						display: none;
					}
				}

				&.react-tabs__tab--disabled {
					color: #fff9;
				}
			}
		}

		.react-tabs__tab-panel {
			background-color: #00000022;
			border-radius: 16px;
			padding: 16px 24px;
		}
	}
`
